import { Header } from "components/atoms/Typography";
import { ByBuildingBarChart, FiltersetBasedEmissionIntensityMap } from "components/organisms/Charts";
import CarbonFinesForecastChart from "components/organisms/Charts/Baseline/CarbonFinesForecastChart/CarbonFinesForecastChart";
import useReportsGroupByState from "recoilStore/useReportsGroupByState";
import useCurrentFilterset from "queries/Reports/Baseline/useCurrentFilterset";

import { CURRENT_YEAR } from "utils/constants";
import "./BaselineReport.css";
import LoadingSpinner from "components/atoms/LoadingSpinner/LoadingSpinner";
import { ReportsCumulativeOperatingCostCard } from "components/organisms/Charts/Recommendations/CumulativeOperatingCostCard";
import AnnualCarbonEmissionsChartContainer from "./ReportCards/AnnualCarbonEmissionsChartContainer";
import AnnualCarbonEmissionsElectricityChart from "./ReportCards/AnnualCarbonEmissionsElectricityChart";
import AnnualCarbonEmissionsNaturalGasChart from "./ReportCards/AnnualCarbonEmissionsNaturalGasChart";
import CurrentAnnualCarbonEmissionsCard from "./ReportCards/CurrentAnnualCarbonEmissionsCard";
import CurrentAnnualEndUseChart from "./ReportCards/CurrentAnnualEndUseChart";
import CurrentAnnualEnergyConsumptionCard from "./ReportCards/CurrentAnnualEnergyConsumptionCard";
import FutureProjectionCards from "./ReportCards/FutureProjectionCards";

function BaselineReport() {
    const { reportedVsPublishedState, selectedFiltersetUid, isLoading: isLoadingFilterset } = useCurrentFilterset();
    const { state: groupByMetric } = useReportsGroupByState();

    if (isLoadingFilterset || !selectedFiltersetUid) {
        return <LoadingSpinner />;
    }

    return (
        <div className="baseline-report">
            <Header size="medium">Your buildings at a glance - {CURRENT_YEAR}</Header>
            <div className="cards-and-chart-grid">
                <div className="cards">
                    <CurrentAnnualCarbonEmissionsCard filtersetUid={selectedFiltersetUid} />
                    <CurrentAnnualEnergyConsumptionCard filtersetUid={selectedFiltersetUid} />
                    <ReportsCumulativeOperatingCostCard
                        filtersetUid={selectedFiltersetUid}
                        reportedVsPublished={reportedVsPublishedState}
                        isBaseline={true}
                        year={CURRENT_YEAR}
                    />
                </div>
                <ByBuildingBarChart filtersetUid={selectedFiltersetUid} />
            </div>
            <div className="side-by-side-charts-grid">
                <CurrentAnnualEndUseChart filtersetUid={selectedFiltersetUid} />
                <FiltersetBasedEmissionIntensityMap
                    includeHeader={true}
                    groupByMetric={groupByMetric}
                    filtersetUid={selectedFiltersetUid}
                    reportedVsPublished={reportedVsPublishedState}
                />
            </div>
            <Header size="medium">Future projection</Header>
            <div className="cards-and-chart-grid">
                <FutureProjectionCards
                    filtersetUid={selectedFiltersetUid}
                    reportedVsPublished={reportedVsPublishedState}
                />
                <AnnualCarbonEmissionsChartContainer filtersetUid={selectedFiltersetUid} />
            </div>
            <div className="side-by-side-charts-grid">
                <AnnualCarbonEmissionsNaturalGasChart filtersetUid={selectedFiltersetUid} />
                <AnnualCarbonEmissionsElectricityChart filtersetUid={selectedFiltersetUid} />
            </div>
            <CarbonFinesForecastChart filtersetUid={selectedFiltersetUid} />
        </div>
    );
}

export default BaselineReport;
